module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lepus/lep_en-bc1491ade3fa24e089829fba6883f5d0.gif";